import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpContext, HttpParams} from '@angular/common/http';
import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {RemarkTypeService} from './remark-type.service';
import {CustomHttpParameterCodec} from '../encoder';
import {Observable} from 'rxjs';

export interface ApiRateCategoryGetRequestParams {
    rateCategoryIds?: Array<number>;
    searchString?: string;
    statusId?: number | string;
    StatusId?: number | string | Array<number>;
    sortColumnName?: string;
    sortAscending?: boolean;
    pageIndex?: number;
    pageSize?: number;
}

export interface ApiRateCategoryListTableExcelGetRequestParams extends ApiRateCategoryGetRequestParams {
    columns?: string;
}

@Injectable({
    providedIn: 'root'
})
export class RateCategoryService extends RemarkTypeService {

    override localVarPath = '/api/ratecategory'

    constructor(
        httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration: Configuration
    ) {
        super(httpClient, basePath, configuration);
    }

    override apiRemarktypeGet(requestParameters: ApiRateCategoryGetRequestParams = {}, observe: any = 'body', reportProgress: boolean = false, options?: {
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const query = this.buildQuery(requestParameters);

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        return this.httpClient.request<any>('get', `${this.configuration.basePath}${this.localVarPath}`,
            {
                context: options?.context || new HttpContext(),
                params: query,
                responseType: 'json',
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: options?.transferCache !== undefined ? options.transferCache : true,
                reportProgress: reportProgress
            }
        );
    }

    public apiRateCategoryListTableExcelGet(requestParameters: ApiRateCategoryListTableExcelGetRequestParams = {}, observe: any = 'body', reportProgress: boolean = false, options?: {
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        let query = this.buildQuery(requestParameters);
        if (requestParameters.columns !== undefined && requestParameters.columns !== null) {
            query = query.append('columns', requestParameters.columns);
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        const localVarPath = `${this.localVarPath}/list/table/excel`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: options?.context || new HttpContext(),
                params: query,
                responseType: <any>'blob',
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: false,
                reportProgress: reportProgress
            }
        );
    }

    private buildQuery(requestParameters: ApiRateCategoryGetRequestParams): HttpParams {
        const rateCategoryIds = requestParameters.rateCategoryIds;
        const searchString = requestParameters.searchString;
        const statusId = requestParameters.statusId ?? requestParameters.StatusId;
        const sortColumnName = requestParameters.sortColumnName;
        const sortAscending = requestParameters.sortAscending;
        const pageIndex = requestParameters.pageIndex;
        const pageSize = requestParameters.pageSize;

        let localVarQueryParameters = new HttpParams({encoder: new CustomHttpParameterCodec()});
        if (rateCategoryIds) {
            rateCategoryIds.forEach((element) => {
                localVarQueryParameters = localVarQueryParameters.append('RateCategoryIds', element);
            });
        }
        if (searchString !== undefined && searchString !== null) {
            localVarQueryParameters = localVarQueryParameters.append('SearchString', searchString);
        }
        if (statusId !== undefined && statusId !== null) {
            if (Array.isArray(statusId)) {
                statusId.forEach((element) => {
                    localVarQueryParameters = localVarQueryParameters.append('StatusId', element);
                });
            } else {
                localVarQueryParameters = localVarQueryParameters.append('StatusId', statusId);
            }
        }
        if (sortColumnName !== undefined && sortColumnName !== null) {
            localVarQueryParameters = localVarQueryParameters.append('Sort.ColumnName', sortColumnName);
        }
        if (sortAscending !== undefined && sortAscending !== null) {
            localVarQueryParameters = localVarQueryParameters.append('Sort.Ascending', sortAscending);
        }
        if (pageIndex !== undefined && pageIndex !== null) {
            localVarQueryParameters = localVarQueryParameters.append('PageIndex', pageIndex);
        }
        if (pageSize !== undefined && pageSize !== null) {
            localVarQueryParameters = localVarQueryParameters.append('PageSize', pageSize);
        }
        return localVarQueryParameters;
    }
}